'use strict';

import HandControllerData from './handControllerData';
import AvatarData from './avatarData';
import AvatarLoader from './avatarLoader';
import {DistanceController} from "../distanceController";


const path = require('path');

class AvatarController {
    constructor() {
        this.allUserMeshGroup = new THREE.Object3D();
        this.userNameMeshList = [];
        this.avatarData = new AvatarData();
        this.handControllerData = new HandControllerData();
        this.avatarLoader = new AvatarLoader(this.onloadAvatar.bind(this));
    }

    onloadAvatar(meshObject) {
        let self = this;

        self.getAvatarData().avatarMeshArray = [];
        self.getAvatarData().avatarMeshArrayBoundingBox = undefined;

        updateAvatarMeshArray(meshObject);

        function updateAvatarMeshArray(meshObject) {
            if (meshObject.isMesh) {
                self.getAvatarData().avatarMeshArray.push(meshObject);
            }

            if (meshObject.hasOwnProperty("children")) {
                meshObject.children.forEach(child => {
                    updateAvatarMeshArray(child);
                })
            }
        }

        self.getAvatarData().avatarMeshArrayBoundingBox = new THREE.Box3().setFromObject(meshObject);

        self.updateAllUserMeshAfterModelLoad();
    }

    updateAllUserMeshAfterModelLoad() {
        let self = this;
        for (let registeredID in wv.effectController.Participants) {
            if (wv.effectController.Participants.hasOwnProperty(registeredID)) {

                const userId = registeredID.toString();
                const userName = wv.effectController.Participants[registeredID].name;

                let userMesh = self.getUserMeshObjectByName(userId);

                if (!userMesh) {
                    return;
                }

                let userHeadMeshGroup = userMesh.getObjectByName(self.getAvatarData().headGroupName);

                let avatarHeadMesh = userMesh.getObjectByName(self.getAvatarData().headName);
                let avatarTooltipMesh = userMesh.getObjectByName(self.getAvatarData().avatarTooltip);

                if (!avatarTooltipMesh) {
                    avatarTooltipMesh = self.createUserMeshName(userId, {customName: userName});
                    userHeadMeshGroup.add(avatarTooltipMesh);
                }

                if (!avatarHeadMesh) {
                    const avatarHeadMeshArray = self.getAvatarHeadMeshArray(avatarTooltipMesh);
                    avatarHeadMeshArray.forEach(mesh => {
                        userHeadMeshGroup.add(mesh);
                    })
                }

                self.updateHeadGroupMaterialColor(userMesh, wv.effectController.avatarSettings.color, wv.effectController.avatarSettings.opacity);
            }
        }
    }

    getAvatarHeadMeshArray(tooltipMesh) {
        let meshArray = [];
        const boundingBoxSize = new THREE.Vector3().subVectors(this.getAvatarData().avatarMeshArrayBoundingBox.max, this.getAvatarData().avatarMeshArrayBoundingBox.min);

        for (let i = 0; i < this.getAvatarData().avatarMeshArray.length; i++) {
            const mesh = new THREE.Mesh(this.getAvatarData().avatarMeshArray[i].geometry, getMaterialForThisMesh(this.getAvatarData().avatarMeshArray[i].material));
            mesh.position.copy(this.getAvatarData().avatarMeshArray[i].position.clone());
            mesh.quaternion.copy(this.getAvatarData().avatarMeshArray[i].quaternion.clone());
            mesh.scale.copy(this.getAvatarData().avatarMeshArray[i].scale.clone());
            mesh.name = this.getAvatarData().headName;

            mesh.position.y += (this.getAvatarData().avatarTooltipPosition.y - boundingBoxSize.y / 2 - tooltipMesh.scale.y / 2);

            meshArray.push(mesh);
        }

        function getMaterialForThisMesh(material) {
            let materialArray = [];

            if (material instanceof Array === false) {
                return material.clone();
            }

            traverseMaterial(material);

            function traverseMaterial(matArray) {
                if (matArray instanceof Array) {
                    matArray.forEach(mat => {
                        traverseMaterial(mat);
                    })
                }

                if (matArray instanceof Array === false) {
                    materialArray.push(matArray.clone());
                }
            }

            return materialArray;
        }

        return meshArray;
    }

    async loadHead() {
        let avatarPath = "models/Head";

        if (wv.settings.avatar) {
            avatarPath = "avatar/" + wv.settings.avatar._id;
        }

        let modelName = "HeadNew.fbx";

        if (wv.effectController.avatar)
            modelName = wv.settings.avatar.core.mainFileName;

        this.avatarLoader.load(path.join(avatarPath, modelName));

        wv.loadAvatarHeadModelCalled = true;
    }

    addUser(user_id, hide_user) {
        if (wv.effectController.Participants[user_id] === undefined)
            return;

        const user_mesh = this.createUser(user_id, wv.effectController.Participants[user_id].name);
        user_mesh.visible = !hide_user;
        this.addUserMeshObject(user_mesh);

        this.updateAvatarVisibility();
    }

    initAvatarHandModel() {
        CommandPromptManager.handleVrModeChange();

        if (wv.loadAvatarHandModelCalled) {
            return;
        }

        let self = this;
        wv.loadAvatarHandModelCalled = true;
        loadHandModels();

        function loadHandModels() {

            const loader = new THREE.GLTFLoader();
            loader.load(
                'models/hand/left hand optimized.glb',
                (gltf) => {
                    const object = gltf.scene;

                    const properties = {
                        object: object,
                        gltf: gltf,
                        controller: wv.controllerLeft
                    };

                    self.setControllerHandObject(properties);
                    self.setHandModelForUserBody(properties);
                },
                undefined,
                (error) => {
                    console.error('Error loading left hand model:', error);
                }
            );

            loader.load(
                'models/hand/right hand optimized.glb',
                (gltf) => {
                    const object = gltf.scene;

                    const properties = {
                        object: object,
                        gltf: gltf,
                        controller: wv.controllerRight,
                    };

                    self.setControllerHandObject(properties);
                    self.setHandModelForUserBody(properties);
                },
                undefined,
                (error) => {
                    console.error('Error loading left hand model:', error);
                }
            );

        }

    }

    setControllerHandObject(properties) {
        const object = properties.object;
        object.rotation.y += this.handControllerData.yAxisRotation;
        object.position.z += this.handControllerData.controllerMeshOffsetZ;
        if (properties.controller === wv.controllerLeft) {
            object.position.x = object.position.x - this.handControllerData.controllerMeshOffsetX;
        } else {
            object.position.x = object.position.x + this.handControllerData.controllerMeshOffsetX;
        }

        const handScale = 100;
        object.scale.set(handScale, handScale, handScale);
        object.name = this.handControllerData.handModelName;

        registerHandAnimation(properties);

        addControllerHandMesh(properties.object, properties.controller);
        PinchFeature.addProximityBoxForPinching(properties.controller);

        properties.object.traverse(child => {
            if (child.isMesh && child.material) {
                if ("color" in child.material) {
                    child.material.color.set(getAdjustedColor(child.material));
                }
            }
        });

        if (properties.controller === wv.controllerLeft) {
            addOffsetToControllerObjectForModelType(properties.controller, this.handControllerData.leftControllerObjectOffset, this.handControllerData.leftLineOffset);
        } else {
            addOffsetToControllerObjectForModelType(properties.controller, this.handControllerData.rightControllerObjectOffset, this.handControllerData.rightLineOffset);
        }

        this.updateControllerForPhysicalTracking(properties.controller, properties.controller.isHandTracking());
    }

    createUserMeshName(userID, options) {
        let userNameMesh;

        options = Object.assign({
            autoUpdate: true,
            customPresenterText: true,
            customName: ""
        }, options);

        let imagePath = 'profile_picture\\avatar.png';
        let userName = "";

        if (wv.effectController.Participants[parseInt(userID)]) {
            userName = wv.effectController.Participants[parseInt(userID)].name;
            imagePath = wv.effectController.Participants[parseInt(userID)].imagePath;
        }

        if (options.customName) {
            userName = options.customName;
        }

        let color = wv.effectController.ParticipantsColor[parseInt(userID)];
        if (color === undefined) color = {r: 0, g: 255, b: 0, a: 1};

        let backgroundColor = {r: 97, g: 217, b: 0, a: 1.0};
        if (color) {
            backgroundColor.r = parseInt(color.r * 255);
            backgroundColor.g = parseInt(color.g * 255);
            backgroundColor.b = parseInt(color.b * 255);
            backgroundColor.a = 1.0;
        }
        const presenterText = localizedController.getText("Presenter", "Presenter");
        if (userName === wv.currentPresenterName && options.customPresenterText) {
            userNameMesh = makeTextSpriteForUserTooltip(imagePath, presenterText + ":\n" + userName, {
                backgroundColor: backgroundColor,
                textColor: {r: 255, g: 255, b: 255, a: 1.0},
            });
        } else {
            userNameMesh = makeTextSpriteForUserTooltip(imagePath, userName, {
                backgroundColor: backgroundColor,
                textColor: {r: 255, g: 255, b: 255, a: 1.0},
            });
        }

        userNameMesh.position.copy(this.avatarData.avatarTooltipPosition);
        userNameMesh.name = this.avatarData.avatarTooltip;
        userNameMesh.isUserTooltip = true;

        if (options.autoUpdate) {
            this.addToAutoUpdateList(userNameMesh)
        }

        return userNameMesh;
    }

    addToAutoUpdateList(userNameMesh) {
        this.userNameMeshList.push(userNameMesh);
        updateTooltipObjLookAt(userNameMesh, iq3Camera.getConfigurationWorld().position);
    }

    deleteUserMeshNameToolTipObject(userMesh) {
        this.removeFromUserMeshNameList(userMesh);
        disposeObject(userMesh);
    }

    removeFromUserMeshNameList(userMesh) {
        const index = this.userNameMeshList.findIndex(mesh => mesh === userMesh);

        if (index !== -1) {
            this.userNameMeshList.splice(index, 1);
        }
    }

    createUserMeshControllers(parent_group) {
        // we need to create the controller mesh after controller model load is done
        // otherwise in slow internet connection will cause problems
        this.createControllerMesh(parent_group);
    }

    createControllerMesh(parent_group) {
        let controller1_obj = new THREE.Object3D();
        let controller1_mesh = new THREE.Mesh(this.handControllerData.controllerGeometryLeft, this.handControllerData.controllerMaterialLeft);
        controller1_mesh.name = this.handControllerData.vive1MeshName;

        controller1_mesh.position.x -= this.handControllerData.controllerMeshOffsetX;
        controller1_mesh.position.z += this.handControllerData.controllerMeshOffsetZ;

        controller1_obj.add(controller1_mesh);
        controller1_obj.name = this.handControllerData.vive1Name;

        let controller2_obj = new THREE.Object3D();
        let controller2_mesh = new THREE.Mesh(this.handControllerData.controllerGeometryRight, this.handControllerData.controllerMaterialRight);
        controller2_mesh.name = this.handControllerData.vive2MeshName;

        controller2_mesh.position.x += this.handControllerData.controllerMeshOffsetX;
        controller2_mesh.position.z += this.handControllerData.controllerMeshOffsetZ;

        controller2_obj.add(controller2_mesh);
        controller2_obj.name = this.handControllerData.vive2Name;

        parent_group.add(controller1_obj);
        parent_group.add(controller2_obj);

        controller1_obj.visible = false;
        controller2_obj.visible = false;
    }

    create_sabers(userMeshGroup) {
        let geometry = new THREE.BufferGeometry();
        geometry.setFromPoints([
            new THREE.Vector3(0, 0, 0),
            new THREE.Vector3(0, 0, -1)
        ]);
        let material = new THREE.LineBasicMaterial({color: 0x00ff00, linewidth: 3});

        // light saber vive controller1
        let line1 = new THREE.Line(geometry, material);
        line1.name = this.handControllerData.vive1SaberName;
        line1.scale.z = wv.controllerDefaultPointerLength;
        line1.visible = this.handControllerData.laser_visible;

        // light saber vive controller2
        let line2 = new THREE.Line(geometry, material);
        line2.name = this.handControllerData.vive2SaberName;
        line2.scale.z = wv.controllerDefaultPointerLength;
        line2.visible = this.handControllerData.laser_visible;

        userMeshGroup.getObjectByName(this.handControllerData.vive1Name).add(line1);
        userMeshGroup.getObjectByName(this.handControllerData.vive2Name).add(line2);
    }

    createUserHeadMesh(user_name, user_id) {
        let group = new THREE.Group();
        group.name = this.getAvatarData().headGroupName;

        const tooltipMesh = this.createUserMeshName(user_id, {customName: user_name});
        group.add(tooltipMesh);

        const avatarHeadMeshArray = this.getAvatarHeadMeshArray(tooltipMesh);

        avatarHeadMeshArray.forEach(mesh => {
            group.add(mesh);
        });

        return group;
    }

    createUser(user_id, user_name) {
        // for shape geometry
        let userMeshGroup = new THREE.Object3D();
        userMeshGroup.name = user_id;

        userMeshGroup.add(this.createUserHeadMesh(user_name, user_id));
        this.createUserMeshControllers(userMeshGroup);
        this.create_sabers(userMeshGroup);

        return userMeshGroup;
    }

    updateHeadGroupMaterialColor(meshObject, color, opacity) {
        let headGroup = meshObject.getObjectByName(this.getAvatarData().headGroupName);

        if (headGroup) {
            headGroup.children.forEach(mesh => {
                if (mesh.name === this.getAvatarData().headName) {
                    traverseAndUpdateMaterialColor(mesh.material, color);
                }
            });
        }

        function traverseAndUpdateMaterialColor(materialArray, color) {
            if (materialArray instanceof Array) {
                materialArray.forEach(mat => {
                    traverseAndUpdateMaterialColor(mat, color);
                })
            }

            if (materialArray instanceof Array === false) {
                materialArray.color = color;
                materialArray.opacity = opacity;
                materialArray.transparent = true;
                materialArray.needsUpdate = true;
            }
        }
    }

    changePresenterTooltip(newPresenterName, oldPresenterName) {
        let newPresenterId = getIdFromUserName(newPresenterName);
        if (newPresenterId) {
            let newPresenterMesh = this.getUserMeshObjectByName(newPresenterId);
            if (newPresenterMesh) {
                let newPresenterTooltip = newPresenterMesh.getObjectByName(this.getAvatarData().avatarTooltip, true);
                let newTooltipParent = newPresenterTooltip.parent;

                newTooltipParent.remove(newPresenterTooltip);
                this.deleteUserMeshNameToolTipObject(newPresenterTooltip);

                let newUpdatedTooltip = this.createUserMeshName(newPresenterId);
                newTooltipParent.add(newUpdatedTooltip);
            }
        }

        let oldPresenterId = getIdFromUserName(oldPresenterName);
        if (oldPresenterId) {
            let oldPresenterMesh = this.getUserMeshObjectByName(oldPresenterId);
            if (oldPresenterMesh) {
                let oldPresenterTooltip = oldPresenterMesh.getObjectByName(this.getAvatarData().avatarTooltip, true);
                let oldTooltipParent = oldPresenterTooltip.parent;

                oldTooltipParent.remove(oldPresenterTooltip);
                this.deleteUserMeshNameToolTipObject(oldPresenterTooltip);

                let oldUpdatedTooltip = this.createUserMeshName(oldPresenterId);
                oldTooltipParent.add(oldUpdatedTooltip);
            }
        }
    }

    updateControllerPosition(user_id, controller1_pos, controller1_orient, controller2_pos, controller2_orient) {
        let user_mesh = this.getUserMeshObjectByName(user_id);

        if (user_mesh) {
            let referenceQuaternion = new THREE.Quaternion();
            user_mesh.getWorldQuaternion(referenceQuaternion);
            referenceQuaternion.invert();
            controller1_pos = user_mesh.worldToLocal(controller1_pos.clone());
            controller1_orient = new THREE.Quaternion().multiplyQuaternions(referenceQuaternion, controller1_orient);
            controller2_pos = user_mesh.worldToLocal(controller2_pos.clone());
            controller2_orient = new THREE.Quaternion().multiplyQuaternions(referenceQuaternion, controller2_orient);

            user_mesh.getObjectByName(this.handControllerData.vive1Name).position.copy(controller1_pos);
            user_mesh.getObjectByName(this.handControllerData.vive1Name).quaternion.copy(controller1_orient);
            DistanceController.updateDistanceLasers(user_mesh.getObjectByName(this.handControllerData.vive1Name));

            user_mesh.getObjectByName(this.handControllerData.vive2Name).position.copy(controller2_pos);
            user_mesh.getObjectByName(this.handControllerData.vive2Name).quaternion.copy(controller2_orient);
            DistanceController.updateDistanceLasers(user_mesh.getObjectByName(this.handControllerData.vive2Name));
        }
    }

    changeToolTipText(userId, changedText) {
        if (userId) {
            let userMesh = this.getUserMeshObjectByName(userId);
            if (userMesh) {
                const userTooltip = userMesh.getObjectByName(this.getAvatarData().avatarTooltip, true);
                const userTooltipParent = userTooltip.parent;

                userTooltipParent.remove(userTooltip);
                this.deleteUserMeshNameToolTipObject(userTooltip);

                const updatedTooltip = this.createUserMeshName(userId, {customName: changedText});
                userTooltipParent.add(updatedTooltip);
                updateTooltipObjLookAt(updatedTooltip, getCameraWorldPositionRef());
            }
        }
    }

    setPhantomMeshVisibility() {
        let mesh = this.getUserMeshObjectByName(SpecialUserIDs.sessionPhantomID);
        if (mesh) {
            mesh.visible = wv.effectController.showSessionPhantom;
        }
    }

    updateAvatarVisibility() {
        this.setPhantomMeshVisibility();
        if (!this.shouldAvatarBeVisible()) {
            for (let userMesh of this.allUserMeshGroup.children) {
                if (userMesh.name !== SpecialUserIDs.sessionPhantomID) {
                    userMesh.visible = false
                }
            }
            return;
        }

        this.allUserMeshGroup.visible = true;

        let currentUserFollowing = false;
        let followedUserId = "0";

        if (wv.effectController.Participants[wv.registeredID.toString()]) {
            currentUserFollowing = wv.effectController.Participants[wv.registeredID.toString()].is_following;
            followedUserId = wv.effectController.Participants[wv.registeredID.toString()].followingUserID || getPresenterId();
            if (followedUserId) {
                followedUserId = followedUserId.toString();
            }
        }

        // show all the mesh except those who are following
        // presenter mesh will be always visible
        for (let key in wv.effectController.Participants) {

            let userMesh = this.getUserMeshObjectByName(key);

            if (!userMesh)
                continue;

            const shouldBeVisible = !wv.effectController.Participants[key].is_following;
            userMesh.visible = shouldBeVisible;

            if (shouldBeVisible) {
                //show locked follower's tooltip
                const lockedFollowerId = wv.effectController.Participants[key].lockedFollowerId;
                if (wv.effectController.Participants[lockedFollowerId])
                    this.changeToolTipText(key, wv.effectController.Participants[lockedFollowerId].name);
                else
                    this.changeToolTipText(key, wv.effectController.Participants[key].name);
            }
            if (key === followedUserId) {
                const headGroupObj = userMesh.getObjectByName(this.getAvatarData().headGroupName);
                if (headGroupObj) {
                    headGroupObj.visible = !currentUserFollowing;
                }
            } else {

                // show the head if previously presenter but not now
                const headGroup = userMesh.getObjectByName(this.getAvatarData().headGroupName);
                if (headGroup) {
                    headGroup.visible = true;
                }

                userMesh.children.forEach(child => {
                    if (child.name === this.getAvatarData().headName) {
                        child.visible = true;
                        child.parent.visible = true;
                    }
                });
            }
        }

        // hide same mesh
        let thisUserMesh = this.getUserMeshObjectByName(wv.registeredID.toString());
        if (thisUserMesh)
            thisUserMesh.visible = false;
    }

    shouldAvatarBeVisible() {
        return (!wv.effectController.loadSessionRunning && wv.effectController.ShowAvatar)
            || (wv.effectController.loadSessionRunning && wv.effectController.showParticipantsInSession);
    }

    show_all_avatar() {
        this.updateAvatarVisibility();
        if (!wv.loadAvatarHeadModelCalled) {
            this.loadHead();
        }
    }

    initShowUserPositionAvatar(show) {
        VR.scene.add(this.allUserMeshGroup);
        this.updateAvatarVisibility();

        if (show) {
            this.loadHead();
        }
    }

    setAllControllerVisibility(userMesh, isVisible) {
        let controller1_saber = userMesh.getObjectByName(this.handControllerData.vive1SaberName);
        if (controller1_saber)
            controller1_saber.visible = isVisible;

        let controller2_saber = userMesh.getObjectByName(this.handControllerData.vive2SaberName);
        if (controller2_saber)
            controller2_saber.visible = isVisible;
    }

    changeControllerLaserVisibility(userId, isVisible) {
        let userMesh = this.getUserMeshObjectByName(userId);
        if (userMesh) {
            this.setAllControllerVisibility(userMesh, isVisible);
        }
    }

    changeControllerStatus(user_mesh, controller, isVisible) {
        if (controller)
            controller.visible = isVisible;
        if (isVisible) {
            this.initAvatarHandModel();
        }
    }

    changeViveControllerLeftStatus(user_id, isVisible) {
        let user_mesh = this.getUserMeshObjectByName(user_id);
        if (!user_mesh)
            return;
        let vive1 = user_mesh.getObjectByName(this.handControllerData.vive1Name);
        this.changeControllerStatus(user_mesh, vive1, isVisible);
    }

    changeViveControllerRightStatus(user_id, isVisible) {
        let user_mesh = this.getUserMeshObjectByName(user_id);
        if (!user_mesh)
            return;

        let vive2 = user_mesh.getObjectByName(this.handControllerData.vive2Name);
        this.changeControllerStatus(user_mesh, vive2, isVisible);
    }

    updateHandMeshVisibility(controller) {
        const visibility = iq3XRSession.mode === SessionMode.AR ? wv.effectController.showVirtualHandsInAR : true;
        const handObject = controller.getObjectByName(wv.controllerMeshObjectName);
        handObject.visible = visibility;
    }

    updateControllerForPhysicalTracking(controller, isHandTracking) {
        const handScale = 100;
        const handPosOffset = new THREE.Vector3(0, 0, 0);
        const handModelScale = new THREE.Vector3(handScale, handScale, handScale);

        if (isHandTracking) {
            const handSize = controller.getHandSize();
            const scale = handSize / wv.controllerDefaultHandSize;
            handModelScale.set(scale * handScale, scale * handScale, scale * handScale);

            handPosOffset.y = this.handControllerData.handTrackingPositionOffsetY;
            handPosOffset.z = this.handControllerData.handTrackingPositionOffsetZ;
        }

        updateControllerOffset(controller, handPosOffset);
        this.updateHandMeshScale(controller, handModelScale);
    }

    updateHandMeshScale(controller, handScale) {
        const controllerObject = controller.getObjectByName(wv.controllerMeshObjectName);
        const handModel = controllerObject.getObjectByName(this.handControllerData.handModelName);
        if (handModel) {
            handModel.scale.copy(handScale);
        }
    }

    updateAllUserMeshLightSaber() {
        this.updateControllerMeshLightSaber();
    }

    updateControllerMeshLightSaber() {
        if (isControllerVisible(wv.controllerLeft)) {
            if (this.handControllerData.vive_available_left === false) {
                this.handControllerData.vive_available_left = true;
                wv.sendTextMessage(text_showViveControllerLeft + text_seperator + wv.registeredID + ":" + 1);
            }
            DistanceController.updateDistanceLasers(wv.controllerLeft);
        } else if (this.handControllerData.vive_available_left === true) {
            this.handControllerData.vive_available_left = false;
            wv.sendTextMessage(text_showViveControllerLeft + text_seperator + wv.registeredID + ":" + 0);
        }

        if (isControllerVisible(wv.controllerRight)) {
            if (this.handControllerData.vive_available_right === false) {
                this.handControllerData.vive_available_right = true;
                wv.sendTextMessage(text_showViveControllerRight + text_seperator + wv.registeredID + ":" + 1);
            }
            DistanceController.updateDistanceLasers(wv.controllerRight);
        } else if (this.handControllerData.vive_available_right === true) {
            this.handControllerData.vive_available_right = false;
            wv.sendTextMessage(text_showViveControllerRight + text_seperator + wv.registeredID + ":" + 0);
        }
    }

    sendControllerStatus() {
        let leftControllerStatus = isControllerVisible(wv.controllerLeft) ? 1 : 0,
            rightControllerStatus = isControllerVisible(wv.controllerRight) ? 1 : 0;

        wv.sendTextMessage(text_showViveControllerLeft + text_seperator + wv.registeredID + ":" + leftControllerStatus);
        wv.sendTextMessage(text_showViveControllerRight + text_seperator + wv.registeredID + ":" + rightControllerStatus);
    }

    setHandModelForUserBody(properties) {
        let skinnedMesh = null;
        properties.object.traverse((child) => {
            if (child.isSkinnedMesh || child.isMesh) {
                skinnedMesh = child;
            }
        });

        if (!skinnedMesh) {
            console.error("No SkinnedMesh found in GLTF Hand model");
            return;
        }

        let geometry = skinnedMesh.geometry.clone();
        if (geometry.getAttribute('skinIndex')) geometry.deleteAttribute('skinIndex');
        if (geometry.getAttribute('skinWeight')) geometry.deleteAttribute('skinWeight');

        let scaleValue = 100;
        let rotationMatrix = new THREE.Matrix4().makeRotationY(toRadians(90));
        let scaleMatrix = new THREE.Matrix4().makeScale(scaleValue, scaleValue, scaleValue);
        let applyMatrix = new THREE.Matrix4().multiplyMatrices(rotationMatrix, scaleMatrix);
        geometry.applyMatrix4(applyMatrix);

        let material = skinnedMesh.material.clone();

        if (properties.controller === wv.controllerLeft) {
            this.handControllerData.controllerGeometryLeft.copy(geometry);
            this.handControllerData.controllerMaterialLeft.copy(material);
        } else {
            this.handControllerData.controllerGeometryRight.copy(geometry);
            this.handControllerData.controllerMaterialRight.copy(material);
        }
    }

    updateUserNameMeshLookAt(camWorldPosRef) {
        try {
            for (let i = 0; i < this.userNameMeshList.length; i++) {
                updateTooltipObjLookAt(this.userNameMeshList[i], camWorldPosRef);
            }
        } catch (error) {
            console.log(error);
        }
    }

    getUserMeshObjectByName(name) {
        return this.allUserMeshGroup.getObjectByName(name);
    }

    addUserMeshObject(meshObject) {
        this.allUserMeshGroup.add(meshObject);
    }

    removeUserMeshObject(meshObject) {
        this.allUserMeshGroup.remove(meshObject);
    }

    getAvatarData() {
        return this.avatarData;
    }
}

export default AvatarController;
